import { render, staticRenderFns } from "./unused-comp_Carousel.vue?vue&type=template&id=6d283097&scoped=true&"
import script from "./unused-comp_Carousel.vue?vue&type=script&lang=js&"
export * from "./unused-comp_Carousel.vue?vue&type=script&lang=js&"
import style0 from "./unused-comp_Carousel.vue?vue&type=style&index=0&id=6d283097&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d283097",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
